class MediaQueryListener {
  constructor(eventListener) {
    this.debounce = 66;
    this.timeout = false;
    this.eventListener = eventListener;
    this.breakPointMap = {
      mobile: { display: 'mobile', value: 0 },
      tablet: { display: 'tablet', value: 1 },
      desktop: { display: 'desktop', value: 2 },
      'xl-display': { display: 'xl-display', value: 3 },
    };

    this.atMinWidth = this.atMinWidth.bind(this);
    this.atMaxWidth = this.atMaxWidth.bind(this);
    this.getBreakPoint = this.getBreakPoint.bind(this);
    this.emitResizeEvent = this.emitResizeEvent.bind(this);

    this.init();
  }

  init() {
    this.setResizeEvent();

    setTimeout(() => {
      this.breakPoint = this.getBreakPoint();

      if (this.breakPoint) {
        this.setResizeEventListener();
      }
    }, this.debounce);
  }

  getBreakPoint() {
    const breakPoint = window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');

    return this.breakPointMap[breakPoint];
  }

  atMaxWidth(view) {
    if (this.breakPoint) {
      const { value } = this.breakPoint;
      const threshold = this.breakPointMap[view];

      if (threshold && threshold.display) {
        return value <= threshold.value;
      }
    }

    return false;
  }

  atMinWidth(view) {
    if (this.breakPoint) {
      const { value } = this.breakPoint;
      const threshold = this.breakPointMap[view];

      if (threshold && threshold.display) {
        return value >= threshold.value;
      }
    }

    return false;
  }

  setResizeEventListener() {
    this.eventListener(this.breakPoint);
    window.addEventListener('windowResize', ({ detail }) => this.eventListener(detail));
  }

  setResizeEvent() {
    if (!window.resizeEvent) {
      window.resizeEvent = (() => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.emitResizeEvent, this.debounce);
      });

      window.addEventListener('resize', window.resizeEvent);
    }
  }

  emitResizeEvent() {
    const currentBreakPoint = this.getBreakPoint();

    if (currentBreakPoint.value !== this.breakPoint.value) {
      this.breakPoint = currentBreakPoint;

      window.dispatchEvent(new CustomEvent('windowResize', { detail: this.breakPoint }));
    }
  }
}

export default MediaQueryListener;
